import { Route, Routes, useLocation, useNavigate, Navigate, useParams } from "react-router-dom";
import "./App.css";
import Landingpage from "./page/Landingpage";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Ourstory from "./page/Ourstory";
import Eventspage from "./page/Eventspage";
import Resources from "./page/Resources";
import CommunityStories from "./page/CommunityStories";
import News from "./page/News";
import Successstories from "./page/Successstories";
import Blog from "./page/Blog";
import Contactus from "./page/Contactas";
import Becomeanally from "./page/Partnerships";
import PartnershipsPage from "./page/PartnershipsPage";
import Help from "./page/Help";
import Donate from "./page/Donate";
import { useEffect } from "react";
import Headermenu from "./components/Headermenu";
import Scrolltotop from "./components/Scrolltotop";
import Privacy from "./page/Privacy";
import Terms from "./page/Terms";
import Ourapp from "./page/Ourapp";
import IndividualBlog from "./page/IndividualBlog";
import { Toaster } from "react-hot-toast";
import DeleteAccountPage from "./page/DeleteAccount";
import DeepLinkHandler from "./page/DeepLinkHandler";
import AppRedirect from "./page/AppRedirect";
import NotFound from "./page/NotFoundPage";
import NewsletterSignupModal from "./components/NewsletterSignupModal";
import DevComponents from "./page/DevComponents";
import useScrollReveal from "./hooks/useScrollReveal";

function RedirectHome() {
  const navigate = useNavigate();
  const { sub } = useParams(); // captures everything after /test/

  useEffect(() => {
    if (sub) {
      navigate(`/${sub}`, { replace: true });
    } else {
      navigate('/', { replace: true });
    }
  }, [sub, navigate]);

  return null;
}

function App() {
  let url = useLocation();
  const navigate = useNavigate();

  useScrollReveal();

  url = url.pathname.replace("/", "");

  useEffect(() => {
    if (url === "index.html") {
      navigate("/");
    }
  }, [url]);

  return (
    <div className="App relative">
      <Header />
      {/* <Headermenu /> */}
      <Scrolltotop />
      <Toaster />
      <NewsletterSignupModal />
      <div className="w-full">
        <Routes>
          <Route path={"/"} element={<Landingpage />} />
          {process.env.NODE_ENV !== "production" && (
            <Route path={"/dev/components"} element={<DevComponents />} />
          )}
          <Route path={"/ourstory"} element={<Ourstory />} />
          <Route path={"/events"} element={<Eventspage />} />
          <Route path={"/resources"} element={<Resources />} />
          <Route path={"/communitystories"} element={<CommunityStories />} />
          <Route path={"/news&updates"} element={<News />} />
          <Route path={"/successstories"} element={<Successstories />} />
          <Route path={"/blog"} element={<Blog />} />
          <Route path={"/blog/:eachblog"} element={<IndividualBlog />} />
          <Route path={"/contactus"} element={<Contactus />} />
          <Route path={"/becomeanally"} element={<Becomeanally />} />
          <Route path={"/partnerships"} element={<PartnershipsPage />} />
          <Route path={"/donate"} element={<Donate />} />
          <Route path={"/help&support"} element={<Help />} />
          <Route path={"/privacy"} element={<Privacy />} />
          <Route path={"/terms_and_conditions"} element={<Terms />} />
          <Route path={"/ourapp"} element={<Ourapp />} />
          <Route path={"/delete-account"} element={<DeleteAccountPage />} />
          <Route path={"/event/:id"} element={<DeepLinkHandler />} />
          <Route path={"/blog/:id"} element={<DeepLinkHandler />} />
          <Route path={"/article/:id"} element={<DeepLinkHandler />} />
          <Route path={"/podcast/:id"} element={<DeepLinkHandler />} />
          <Route path={"/download-app"} element={<AppRedirect />} />
          <Route path={"*"} element={<NotFound />} />
          {/* For handling the old /home subpath, will be removed in future */}
          <Route path={"/home/:sub"} element={<RedirectHome />} />
          <Route path={"/home"} element={<RedirectHome />} />
        </Routes>
        <Footer />
      </div>
    </div>
  );
}

export default App;
